import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { MdIconRegistry } from '@angular/material'

@Component({
  moduleId: module.id,
  selector: 'cm-navigation-toolbar',
  templateUrl: './navigation-toolbar.component.html',
  styleUrls: ['./navigation-toolbar.component.css']
})
export class NavigationToolbarComponent implements OnInit {

  constructor(private iconRegistry: MdIconRegistry,
    private domSanitizer: DomSanitizer) { 
    
    iconRegistry.addSvgIcon(
      'film',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/img/icon/ic_film.svg')
    )
    iconRegistry.addSvgIcon(
      'discussion',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/img/icon/ic_discussion.svg')
    )
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/navigation-toolbar/navigation-toolbar.component.ts